export enum FlagPrevisao {
  COM_PREVISAO = 'P',
  SEM_PREVISAO  = 'C',
}
